import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import { withRouter, Redirect} from "react-router-dom";
import { AuthContext } from "../Auth";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from "../images/logo text.png" 
import Risk from "../images/risk.png"
import Search from "../images/search.png"
import Logo2 from "../images/logo pic.png" 
import "../App.css"
import "../css/bootstrap.css"
import "../css/styles.css"
import Start from "../images/start.png"
import Sugges from "../images/Sugges.png"
import form1 from "../images/form1.png"
import form2 from "../images/form2.png"
import form3 from "../images/form3.png"
import form4 from "../images/form4.png"
import form5 from "../images/form5.png"
import form6 from "../images/form6.png"
import form7 from "../images/form7.png"
import form8 from "../images/form8.png"
import form9 from "../images/form9.png"
import form10 from "../images/form10.png"
import form11 from "../images/form11.png"
import form12 from "../images/form12.png"

export const Forms = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [Formstatus, setFormstatus] = useState("");
  const db = app.firestore();
  useEffect (() => {
    const documentRef = db.collection('EIPCAFORM').doc(currentUser.uid);
    documentRef.get().then((doc) => {
      if (doc.exists) {
        let formstatusArray = [];
        formstatusArray.push(doc.data());
        const myStringValue = formstatusArray[0].Form_Result;
        setFormstatus(myStringValue);
        
      } else {
        console.log("No such document!");
        SkipBtn = <p></p>
      }
    }).catch((error) => {
      console.log("Error getting document:", error);
    });
  })

  let SkipBtn;
  let Text;
  if (Formstatus == "No_Risk"){
    SkipBtn = 
    <a className=" " style={{marginLeft: "60%"}} href="/Hardware">
       
    </a>
    
  } else if (Formstatus == "Low_Risk") {
    SkipBtn = 
    <a className=" " style={{marginLeft: "60%"}} href="/Hardware">
       
    </a>
    
  } else if (Formstatus == "Medium_Risk") {
    SkipBtn = 
    <a className="" style={{marginLeft: "60%"}} href="/Hardware">
       
    </a>
    
  } else if (Formstatus == "High_Risk") {
    SkipBtn = 
    <a className=" " style={{marginLeft: "60%"}} href="/Hardware">
       
    </a>
    Text =""
  } else {
    SkipBtn = 
    <p></p>
  };
  
  const questions = [
    {
      img: form1,
      question: "เพศหญิง อายุมากกว่า 55 ปี / เพศชาย อายุมากกว่า 45 ปี",
      answer: "yes",
      page: "1/12"
    },
    {
      img: form2,
      question: "คุณสูบบุหรี่หรือได้รับควันบุหรี่อย่างต่อเนื่อง/เลิกบุหรี่ไม่เกิน 2 ปี",
      answer: "yes",
      page: "2/12"
    },
    {
      img: form3,
      question: "มีความดันโลหิตสูงมากกว่า 140/90 มิลลิเมตรปรอท",
      answer: "yes",
      page: "3/12"
    },
    {
      img: form4,
      question: "มีค่าไขมันในเลือดสูงผิดปกติ (ค่าโคเลสเตอรอล มากกว่า 200 มิลลิกรัมเปอร์เซนต์)",
      answer: "yes",
      page: "4/12"
    },
    {
      img: form5,
      question: "ขาดการออกกำลังกายหรือออกกำลังกายน้อยกว่า 3 ครั้ง/สัปดาห์ (30 นาที/ครั้ง)",
      answer: "yes",
      page: "5/12"
    },
    {
      img: form6,
      question: "น้ำหนักเกินมาตรฐาน (ดรรชนีมวลกายมากกว่า 25 kg/m^2) อ้วนลงพุง รอบเอวมากกว่า ชาย 90 ซม.(36 นิ้ว)/หญิง 80 ซม. (32 นิ้ว)",
      answer: "yes",
      page: "6/12"
    },
    {
      img: form7,
      question: "บุคคลใคครอบครัวสายตรงมีประวัติเป็นโรคหลอดเลือดหัวใจตีบ",
      answer: "yes",
      page: "7/12"
    },
    {
      img: form8,
      question: "เป็นโรคเบาหวานหรือระดับน้ำตาลในเลือดผิดปกติมากกว่า 100 mg/dl",
      answer: "yes",
      page: "8/12"
    },
    {
      img: form9,
      question: "มีภาวะตึงเครียดอยู่เสมอ",
      answer: "yes",
      page: "9/12"
    },
    {
      img: form10,
      question: "รู้สึกเหนื่อยง่าย เหนื่อยผิดปกติขณะออกกำลังกาย หรือเมื่อออกแรง / เดินขึ้นบันได 2 ชั้น",
      answer: "yes",
      page: "10/12"
    },
    {
      img: form11,
      question: "มีอาการจุกเสียด แน่นหน้าอกหรือบริเวณลิ้นปี่ เมื่อออกแรง",
      answer: "yes",
      page: "11/12"
    },
    {
      img: form12,
      question: "มีอาการใจเต้น ใจสั่น เป็นลม หน้ามืดหรือหมดสติโดยไม่ทราบสาเหตุ",
      answer: "yes",
      page: "12/12"
    },
  ];

  const handleAnswer = (answer) => {
    setAnswers([...answers, answer]);
    setCurrentQuestion(currentQuestion + 1);
  };

  const renderQuiz = () => {
    const db = app.firestore();
    const DBref = db.collection("EIPCAFORM").doc(currentUser.uid);
    if (currentQuestion === questions.length) {
      // Quiz completed, show results
      const correctAnswers = answers.filter(
        (answer, index) => answer === questions[index].answer
      );
      let result;
      let resultimg;
      let suggestion;
      let Button;
      let suggestionButton;
      if (correctAnswers.length > 10) {
        result = "คุณมีความเสี่ยงสูงที่จะเป็นโรคหัวใจ!";
        resultimg = "";
        suggestion = "คุณควรไปพบแพทย์โดยเร็วที่สุด";
        DBref.set({
          "Form_Result" : "High_Risk"
        })
        
      
      } else if (correctAnswers.length > 8) {
        result = "คุณมีความเสี่ยงปานกลางที่จะเป็นโรคหัวใจ!";
        resultimg = "";
        suggestion = "คุณควรออกกำลังกายอย่างสม่ำเสมอ และควรตรวจสุขภาพเป็นประจำอย่างน้อยปีละ 2-3 ครั้ง";
        DBref.set({
          "Form_Result" : "Medium_Risk"
        })
        
       
      } else if (correctAnswers.length > 5) {
        result = "คุณมีความเสี่ยงต่ำที่จะเป็นโรคหัวใจ!";
        resultimg = "";
        suggestion = "คุณควรเริ่มออกกำลังกาย และควรตรวจสุขภาพเป็นประจำอย่างน้อยปีละ 1 ครั้ง"
        DBref.set({
          "Form_Result" : "Low_Risk"
        })
        

      } else {
        result = "คุณไม่มีความเสี่ยงที่จะเป็นโรคหัวใจ";
        resultimg = "";
        suggestion = "ควรตรวจสุขภาพเป็นประจำอย่างน้อยปีละ 1 ครั้ง"
        DBref.set({
          "Form_Result" : "No_Risk"
        })
        
      }
      console.log(result)

      
      return(
      
      <div>
        <img src={resultimg} style={{width: "10%" , marginTop: "1%" , borderRadius: "10px"}}/>
        <h2 style={{marginTop : "1%" ,padding: "50px", borderRadius: "10px" , marginBottom: "1%"}}  className="bg-gray">{result}<br/>{suggestion}</h2>
        <center>
        <a>{Button}</a>
        <div>{suggestionButton}</div>
        </center>
        <center>
  <div id="jobPanel" className="filter">
    <div className="basic-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Job */}
            <div className="job-container">
              <a style={{textDecoration: "none"}} href="/Hardware">
              <img
                className="img6"
                src={Start}
              />
              </a>
            </div>{" "}
            <div className="job-container " >
              <a style={{textDecoration: "none"}} href="/SuggestionBad">
              <img
                className="img6"
                src={Sugges}
              />
              </a>
            </div>{" "}
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
      </div>{" "}
      {/* end of container */}
    </div>{" "}
    {/* end of basic-3 */}
  </div>

  </center>
        
        
        
        
      </div>
      
      
      
      );
        

    } else {
      // Show current question
      const question = questions[currentQuestion];
      return (
        
        
        <div style={{marginTop: "20px",padding: "30px", borderRadius: "10px"}} className="bg-gray">
            <div>
             {SkipBtn}
            </div>
          <h2>{question.page}</h2>
          <img style={{marginBottom: "3%" , borderRadius: "10px" , width: "30%"}} src = {question.img}/>
          <h2>{question.question}</h2>
          <button className="mx-3 btn-solid-lg" onClick={() => handleAnswer("yes")}>ใช่</button>
          <button className="btn-solid-lg" onClick={() => handleAnswer("no")}>ไม่ใช่</button>
        </div>
        
        
        
      );
    }
  };
  



  
  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };

  

// Change file to Field for firestore

  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/home" >
              บริการ <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/">
              ข่าวสารจาก EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/about">
              เกี่ยวกับเรา
            </Nav.Link>
          </li>
        </center>
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >ออกจากระบบ</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/Form">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/Form">
              EN
            </Nav.Link>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
  <center>  
   {/* Header */}
  <header className="ex-header bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1 my-3">
          <h1>แบบประเมินความเสี่ยงการเกิดโรคหัวใจ  </h1>
          <h4>{Text}</h4>
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
    <div>
      
    </div>
    <div>{renderQuiz()}</div>
    
    
</center>

<br/>
<br/>
<br/>
<br/>
      
    </>
  );
};

export default withRouter(Forms);


